import React from 'react';

import CatalogShell from './CatalogShell';

const NotificationChannels: React.FC = () => (
  <CatalogShell
    slug="notification-channels"
    title="Notification channels"
    breadcrumbLabel="Notification channels"
    emptyBody="Channels are how messages are delivered — email, SMS, push. Tenants pick from this list when configuring notification templates."
    addCtaLabel="Add first channel"
  />
);

export default NotificationChannels;
